import {FC} from 'react'
import {OrderItemModel} from '../models/OrderItemModel'
import PhotoCard from './PhotoCard'

interface Props {
  items: OrderItemModel[]
}

const MasonryGallery: FC<Props> = ({items}) => {
  return (
    <div className='masonry-gallery'>
      {items.map((item) => (
        <div key={item.id} className='masonry-gallery__item'>
          <PhotoCard item={item} />
        </div>
      ))}
    </div>
  )
}

export default MasonryGallery
